import relayService from 'shared/utils/relay'
import GlobalErrorBoundary from 'shared/components/ErrorBoundary/Global'

import { RelayEnvironmentProvider } from 'react-relay'

import GlobalStyles from 'consumer-mobile-web/components/GlobalStyles'
import App from 'consumer-mobile-web/screens/DirectMobileWeb'
import 'consumer-mobile-web/logging/rollbarConfigure'
import 'shared/utils/polyfills'
import renderToDOM from 'shared/applicationRenderer'

if (relayService.environment) {
  renderToDOM(
    <RelayEnvironmentProvider environment={relayService.environment}>
      <GlobalErrorBoundary message="Please refresh the page.">
        <GlobalStyles />
        <App />
      </GlobalErrorBoundary>
    </RelayEnvironmentProvider>
  )
}
